import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { useDispatch } from 'react-redux';

const classUtils = MojitoCore.Base.classUtils;
const { Button, Text } = MojitoPresentation.Components;
const betslipActions = MojitoServices.Betslip.actions;
const BetslipTypes = MojitoServices.Betslip.types;

const RemoveAllButton = ({ config, stringResolver, class: className }) => {
    const dispatch = useDispatch();
    return (
        <Button
            config={config.removeAllButton}
            onClick={() => onRemoveAllClicked(dispatch)}
            class={classUtils.classNames('ta-removeAllBtn', className)}
        >
            <Text class="ta-RemoveAllButtonText" config={config.removeAllButtonText}>
                {stringResolver.resolveString('$BETSLIP.REMOVE_ALL')}
            </Text>
        </Button>
    );
};

const onRemoveAllClicked = dispatch =>
    dispatch(betslipActions.clearBetslip([BetslipTypes.BETSLIP_PART.SETTINGS]));

export default RemoveAllButton;
